import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useOutsideClick } from '../../hooks/index.js';
import { StyledArrow, StyledPopover, StyledPopoverContainer } from './index.styles.js';
import { useEscapeKey } from './utils/use-esc-key-listener.js';
import { usePopoverPosition } from './utils/use-popover-position.js';
import { Transition } from 'react-transition-group';
import { useFocusTrap } from '../../utils/use-focus-trap.js';
import { useScroll } from './utils/use-scroll.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const Popover = ({ triggerElement, content, open, onClose, id, withTip = true, targetRef, zIndex, role = 'dialog', alignment = 'center', placement = 'bottom', 'aria-label': ariaLabel, ...rest }) => {
    const popoverId = id;
    const bubbleRef = useRef(null);
    const triggerRef = useRef(null);
    const [isClient, setIsClient] = useState(false);
    const dataProps = pickDataProps(rest);
    useFocusTrap({
        open,
        ref: bubbleRef,
        triggerRef
    });
    useOutsideClick([bubbleRef, triggerRef], onClose);
    useEscapeKey(onClose);
    const actualPlacement = usePopoverPosition({
        ref: bubbleRef,
        alignment,
        placement,
        open,
        triggerRef: targetRef ?? triggerRef,
        withTip
    });
    useScroll({ open, callback: onClose });
    const triggerProps = {
        'aria-expanded': open,
        'aria-haspopup': triggerElement.props['aria-haspopup'] ?? 'dialog',
        'aria-controls': popoverId,
        ref: triggerRef
    };
    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);
    if (!isClient) {
        return null;
    }
    return (React.createElement(StyledPopoverContainer, { ...dataProps },
        React.cloneElement(triggerElement, triggerProps),
        React.createElement(Transition, { nodeRef: bubbleRef, in: open, timeout: 125, unmountOnExit: true }, (state) => createPortal(React.createElement(StyledPopover, { withTip: withTip, id: popoverId, role: role, ref: bubbleRef, "aria-hidden": !open, "aria-label": ariaLabel, state: state, placement: placement, zIndex: zIndex },
            withTip && (React.createElement(StyledArrow, { direction: actualPlacement ?? 'bottom' })),
            content), document.body))));
};
//# sourceMappingURL=index.js.map